module.exports = __webpack_public_path__ + "img/logo.79f188f3.png";